import { AppId } from 'types/shared/documents/restaurants/apps';
import useRestaurant from './useRestaurant';

export type AppActivation = 'loading' | 'active' | 'inactive';

type LoadedApps = { restaurantId: string | null; apps?: AppId[]; appsRestaurantId?: string | null };

/**
 * Whether an app is active for the restaurant shown. Until that restaurant's
 * own app list arrived (first load, restaurant switch, a screen of another
 * restaurant) the answer is 'loading', never the previous restaurant's apps.
 */
export const appActivation = (loaded: LoadedApps, appId: AppId, restaurantId?: string | null): AppActivation => {
  const shown = restaurantId ?? loaded.restaurantId;
  if (!shown || shown !== loaded.restaurantId || loaded.appsRestaurantId !== shown) return 'loading';
  return (loaded.apps ?? []).includes(appId) ? 'active' : 'inactive';
};

const useAppActivation = (appId: AppId, restaurantId?: string | null): AppActivation =>
  appActivation(useRestaurant(), appId, restaurantId);

export default useAppActivation;
